export var EUCMFilePrivacyState;
(function (EUCMFilePrivacyState) {
    EUCMFilePrivacyState[EUCMFilePrivacyState["Invalid"] = -1] = "Invalid";
    EUCMFilePrivacyState[EUCMFilePrivacyState["Private"] = 2] = "Private";
    EUCMFilePrivacyState[EUCMFilePrivacyState["FriendsOnly"] = 4] = "FriendsOnly";
    EUCMFilePrivacyState[EUCMFilePrivacyState["Public"] = 8] = "Public";
    EUCMFilePrivacyState[EUCMFilePrivacyState["Unlisted"] = 16] = "Unlisted";
})(EUCMFilePrivacyState || (EUCMFilePrivacyState = {}));
